import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from './locales/en.json'
import de from './locales/de.json'
import sq from './locales/sq.json'
import mk from './locales/mk.json'

const savedLang = localStorage.getItem('unicodes-lang')
const browserLang = navigator.language?.slice(0, 2)
const supported = ['en', 'de', 'sq', 'mk']
const defaultLang = savedLang && supported.includes(savedLang)
  ? savedLang
  : supported.includes(browserLang)
    ? browserLang
    : 'en'

i18n.use(initReactI18next).init({
  resources: {
    en: { translation: en },
    de: { translation: de },
    sq: { translation: sq },
    mk: { translation: mk },
  },
  lng: defaultLang,
  fallbackLng: 'en',
  interpolation: { escapeValue: false },
})

i18n.on('languageChanged', (lng) => {
  localStorage.setItem('unicodes-lang', lng)
  document.documentElement.lang = lng
})

document.documentElement.lang = defaultLang

export default i18n
